'use client'
import AccordionLayout from '@/components/AccordionLayout'
import { Link } from 'navigation'
import { useMessages, useTranslations } from 'next-intl'
import React, { useState } from 'react'

const ChaufferPartnerFAQ = () => {
  const t = useTranslations('chauffeurPage.chaufferPartnerFAQ')
  const messages = useMessages()
  const faqs = Object.keys(messages['chauffeurPage']['chaufferPartnerFAQ']['FAQDetails'])
  const [isExpandedIndex, setIsExpandedIndex] = useState(null)
  const handleToggleAccordion = (index) => {
    setIsExpandedIndex(isExpandedIndex === index ? null : index)
  }

  return (
    <section>
      <div className='container px-[15px] md:px-0 py-12 md:py-24'>
        <h3 className='heading-common mb-12'>{t('title')}</h3>
        {faqs.map((faq, index) => {
          const answerKey = `FAQDetails.${faq}.answer`
          return (
            <AccordionLayout
              priveFaq={true}
              key={faq}
              title={t(`FAQDetails.${faq}.question`)}
              content={t.rich(answerKey, {
                a: (chunks) => (
                  <Link
                    target='_self'
                    className='text-blue-600 hover:underline'
                    href={`https://partner.rolzo.com/auth/${chunks}`}
                  >
                    {`https://partner.rolzo.com/auth/${chunks}`}
                  </Link>
                ),
                strong: (chunks) => (
                  <strong className='!font-normal'>{chunks}</strong>
                ),
                ul: (chunks) => (
                  <ul className='list-disc ml-6 my-2'>{chunks}</ul>
                ),
                li: (chunks) => <li className='mb-1'>{chunks}</li>,
                br: () => <br></br>,
              })}
              index={index}
              isExpanded={isExpandedIndex === index}
              onToggle={handleToggleAccordion}
            />
          )
        })}
      </div>
    </section>
  )
}

export default ChaufferPartnerFAQ
